import { EditMessage } from "../messages/EditMessage";
import { Context } from "../../lib/context";
export class EditContext extends Context {
    constructor(map, p_layer, m_layer) {
        super(map);
        this.p_layer = p_layer;
        this.m_layer = m_layer;
        this.name = 'edit';
        this.has_edit = true;
        this.has_markers = true;
        this.has_table = true;
        this.exit_contexts = ['selection', 'toolbar'];
    }
    on_enter() { }
    on_exit() { }
    async click_handler(coord, alt) {
        await this.p_layer.add_feature_at_point(coord, alt);
        let id = this.p_layer.clicked;
        if (id) {
            this.m_layer.toggle_marker_at_parcel(id);
            new EditMessage({
                command: 'EDIT',
                strap: id,
                clicked: true,
                alt: alt
            }).send();
        }
    }
    zoom() { }
}
